"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateExternalApi = function (api) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return keys.forEach(function (key) {
        if (!api || typeof api[key] !== 'function') {
            throw new Error("bsiManager: " + key + " must be a function");
        }
    });
};
exports.readCookie = function (name) {
    var regex = RegExp('^\\s*' + name + '=\\s*(.*?)\\s*$');
    var cookies = [];
    try {
        cookies = window.document.cookie.split(';');
    }
    catch (e) { }
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var match = cookie.match(regex);
        if (match) {
            return match[1];
        }
    }
    return null;
};
exports.writeCookie = function (name, value, expires, path) {
    var cookie = name + "=" + value + "; expires=" + new Date(expires).toUTCString() + "; path=" + path + "; SameSite=None; Secure";
    try {
        window.document.cookie = cookie;
    }
    catch (e) { }
};
exports.destroyCookie = function (name, path) {
    exports.writeCookie(name, null, 0, path);
};
exports.getNextLocalMidnight = function () {
    return new Date(Date.now() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0);
};
//# sourceMappingURL=utils.js.map